import React from 'react'
import parameterService from '../../../services/parameterService';

class NameInput extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        
        const prefillData = parameterService.prefillData
        const value = (prefillData.Cardholder.length > 0) ? prefillData.Cardholder : '';

        this.state = {
            value: value
        }
    }

    onChange(e) {
        const { value } = e.target;
        this.setState({ value });
        this.props.onChange(value);
    }

    onBlur(e) {
        this.props.onBlur && this.props.onBlur(e.target.value);
    }

    render() {
        const { error } = this.props;
        const { value } = this.state;

        return (
            <div className={['input-container', value.length === 0 ? 'is-empty' : ''].join(' ')}>
                <label htmlFor={this.props.id} className="text-nowrap">
                    {error || this.props.placeholder}
                </label>
                <input className="form-control"
                       type="text"
                       id={this.props.id}
                       value={value}
                       onChange={this.onChange}
                       onBlur={this.onCardBlur}
                       placeholder={this.props.placeholder}
                       autoComplete="cc-name"
                       autoCorrect="off"
                       spellCheck="false"
                />

            </div>
        )
    }
}

export default NameInput;



// WEBPACK FOOTER //
// ./src/components/CreditCard/CardHolderNameInput/index.js